import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import * as actions from "../../../../store/actions";
import constants, {
  DEFAULT_PIC,
  getDashboardPath,
  NOTIFICATION_BELL,
  NO_DATA_FOUND,
} from "../../../../constants";

import "./VisitNow.css";

import Button from "../../../../components/formElements/button/Button";
import Modals from "../../../../components/uiElements/popupModal/modal";
import PatientProfile from "../../Patients/PatientProfile";
import audioService from "../../../../services/audioService";
import format from "date-fns/format";

const VisitNow = ({
  appointment,
  getVisitNowAppointment,
  history,
  updateVisitNowRequestStatus,
  reviewChartNotification,
  placeHoldOnCard,
  getRequestedAppointments,
  getScheduledAppointments,
  setAppointmentData,
}) => {
  const [page, setPage] = useState(1);
  const [reviewPatient, setReviewPatient] = useState(false);

  const selectedScheduleDate = format(new Date(),
    "yyyy-MM-dd"
  );

  useEffect(() => {
    getVisitNowAppointment();
    getRequestedAppointments(page);
    getScheduledAppointments(1, selectedScheduleDate);
  }, [getVisitNowAppointment]);

  const onAccept = () => {
    audioService.stop();
    
    // Handle test appointment
    if (appointment?.id === 'test-123') {
      setAppointmentData({ visitNow: {} }); // Clear test appointment
      return;
    }
    
    if (
      appointment.doctor_status == "REQUESTED" ||
      appointment.guest_doctor_status == "REQUESTED"
    ) {
      if (appointment?.is_subscribed_patient) {
        updateVisitNowRequestStatus(
          appointment?.id,
          constants.APPOINTMENT_STATUS.accepted,
          false,
          () =>
            history.push({
              pathname: getDashboardPath("/appointments/start-call"),
              state: { appointment_type: "visit_now_appointment" },
            })
        )
      } else {
        placeHoldOnCard(appointment?.id, () =>
          updateVisitNowRequestStatus(
            appointment?.id,
            constants.APPOINTMENT_STATUS.accepted,
            false,
            () =>
              history.push({
                pathname: getDashboardPath("/appointments/start-call"),
                state: { appointment_type: "visit_now_appointment" },
              })
          )
        );
      }
    } else {
      if (appointment?.is_subscribed_patient) {
        updateVisitNowRequestStatus(
          appointment?.id,
          constants.APPOINTMENT_STATUS.accepted,
          false,
          () =>
            history.push({
              pathname: getDashboardPath("/appointments/start-call"),
              state: { appointment_type: "visit_now_appointment" },
            })
        )
      } else {
        placeHoldOnCard(appointment?.id, () =>
          updateVisitNowRequestStatus(
            appointment?.id,
            constants.APPOINTMENT_STATUS.accepted,
            true,
            () =>
              history.push({
                pathname: getDashboardPath("/appointments/start-call"),
                state: { appointment_type: "visit_now_appointment" },
              })
          )
        );
      }
      }
  };

  const onDeny = () => {
    audioService.stop();
    
    // Handle test appointment
    if (appointment?.id === 'test-123') {
      setAppointmentData({ visitNow: {} }); // Clear test appointment
      return;
    }
    
    updateVisitNowRequestStatus(
      appointment?.id,
      constants.APPOINTMENT_STATUS.denied
    );
  };

  return (
    <>
      <Modals
        isOpen={reviewPatient}
        title="Review Patient Profile"
        styles={{
          content: {
            minWidth: "1000px",
            maxWidth: "1000px",
            minHeight: "95vh",
            maxHeight: "95vh",
            overflow: "auto",
          },
        }}
      >
        <React.Fragment>
          <button
            onClick={() => {
              localStorage.removeItem("visitNowPatientId");
              setReviewPatient(false);
            }}
            className="close modalCloseBtn"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div
            style={{
              padding: 20,
              paddingTop: 25,
            }}
          >
            <PatientProfile
              modalViewMode={true}
              onAccept={() => {
                setReviewPatient(false);
                onAccept();
              }}
              onDeny={() => {
                setReviewPatient(false);
                onDeny();
              }}
              appointment={appointment}
            />
          </div>
        </React.Fragment>
      </Modals>
      {!appointment || Object.keys(appointment)?.length === 0 ? (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      ) : (
        <div className="visit-now mx-auto my-4" onClick={() => {
          // Enable audio on user interaction if not already playing
          if (appointment && !audioService.isPlaying) {
            audioService.play();
          }
        }}>
          <div className="mx-auto text-center">
            <img
              src={NOTIFICATION_BELL}
              width={266}
              height={200}
              className="mx-auto content-center"
              alt="notification_bell"
            />
            <p
              className="slotTitle"
              style={{
                fontSize: 20,
              }}
            >
              Incoming appointment request
            </p>
            {audioService.isPlaying && (
              <p style={{ color: "#007bff", fontSize: 14, marginTop: 10 }}>
                🔊 Ringing... (Click anywhere if you don't hear the sound)
              </p>
            )}
            <div className="row mt-5">
              <span className="content-center mb-3 mx-auto col-md-7">
                <img
                  src={appointment?.patient?.image || DEFAULT_PIC}
                  className="profile-image-primary content-center"
                  alt="profile_image_1"
                />
                <span
                  className="col-md-10 text-left"
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  <p
                    className="m-0 appointment-font-secondary"
                    style={{
                      fontSize: 20,
                    }}
                  >
                    {appointment?.patient?.first_name}{" "}
                    {appointment?.patient?.last_name}{" "}
                    <span className="appointment-font-primary"> • Patient</span>
                  </p>
                  <p className="m-0">Topic: {appointment?.topic}</p>
                  <p
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      reviewChartNotification(appointment?.id, () => {
                        localStorage.setItem(
                          "visitNowPatientId",
                          appointment?.patient?.id
                        );
                        setReviewPatient(true);
                        audioService.stop();
                      });
                    }}
                  >
                    View Profile{" "}
                  </p>
                </span>
              </span>
            </div>
            <div className="row">
              <span className="content-center mb-3 mx-auto col-md-7">
                <img
                  src={
                    (appointment?.parent_details?.user__image
                      ? appointment?.parent_details?.user__image
                      : appointment?.doctor?.image) || DEFAULT_PIC
                  }
                  className="profile-image-primary content-center"
                  alt="profile_image_2"
                />
                <span
                  className="col-md-10 text-left"
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  <p
                    className="m-0 appointment-font-secondary"
                    style={{
                      fontSize: 20,
                    }}
                  >
                    {appointment?.parent_details?.user__first_name ||
                      appointment?.doctor?.first_name}{" "}
                    {appointment?.parent_details?.user__last_name ||
                      appointment?.doctor?.last_name}{" "}
                  </p>
                  <p className="m-0">
                    {appointment?.parent_details
                      ? "PARENT"
                      : appointment?.guest_doctor?.speciality?.join(", ")}
                  </p>
                </span>
              </span>
            </div>
            <div className="row mt-3">
              <div className="content-center col-md-12">
                <Button
                  label={
                    appointment.doctor_status == "REQUESTED" ||
                    appointment.guest_doctor_status == "REQUESTED"
                      ? "Accept and start call"
                      : "Rejoin"
                  }
                  className="col-md-4 float-left mr-5"
                  onClick={() => onAccept()}
                />
                <Button
                  label={
                    appointment.doctor_status == "REQUESTED" ||
                    appointment.guest_doctor_status == "REQUESTED"
                      ? "Deny"
                      : "End"
                  }
                  className="col-md-4 float-right ml-5"
                  onClick={() =>
                    appointment.doctor_status == "REQUESTED"
                      ? onDeny()
                      : updateVisitNowRequestStatus(
                          appointment?.id,
                          constants.APPOINTMENT_STATUS.completed,
                          false,
                          () =>
                            history.push({
                              pathname: getDashboardPath("/appointments"),
                            })
                        )
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStoreToProps = ({ dashboard }) => ({
  appointment: dashboard.appointments?.visitNow,
});

const mapDispatchToProps = dispatch => ({
  getVisitNowAppointment: () => dispatch(actions.getVisitNowAppointment()),
  updateVisitNowRequestStatus: (aptId, status, value, cb) =>
    dispatch(actions.updateVisitNowRequestStatus(aptId, status, value, cb)),
  reviewChartNotification: (aptId, cb) =>
    dispatch(actions.reviewChartNotification(aptId, cb)),
  placeHoldOnCard: (appointmentId, cb) =>
    dispatch(actions.placeHoldOnCard(appointmentId, "VISIT_NOW", cb)),
  setAppointmentData: updatedData =>
    dispatch(actions.setAppointmentData(updatedData)),
    getRequestedAppointments: page =>
    dispatch(
      actions.getAppointments([constants.APPOINTMENT_STATUS.requested],page)
    ),
    getScheduledAppointments: (page, date) =>
     
    dispatch(actions.getAppointments(
        [constants.APPOINTMENT_STATUS.accepted,constants.APPOINTMENT_STATUS.cancelled,constants.APPOINTMENT_STATUS.completed
        ,constants.APPOINTMENT_STATUS.noshow],
        page,
        date
      )
    ),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(VisitNow)
);
